import React, { Component } from "react";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import { createStripe } from "../store/actions/authActions";

import MenuFunc from "./Menu";

//import InjectedCheckoutForm from "./CheckoutForm";
//import InjectedCheckoutFormButtons from "./CheckoutFormButtons";

//import { loadStripe } from "@stripe/stripe-js";
//import { Elements } from "@stripe/react-stripe-js";

class Checkout extends Component {
  state = {
    menuToggled: false,
    showform: false,
  };

  componentDidMount() {
    if (this.props.match.params.status !== "ko") {
      ReactGA.event({
        category: "User",
        action: "Free Trial",
      });

      ReactPixel.track("StartTrial");
    } else {
      ReactGA.event({
        category: "User",
        action: "Trial Failed",
      });
    }
  }

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    const { status } = this.props.match.params;

    return (
      <div>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "28px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                {status === "ko"
                  ? "Une erreur s'est produite"
                  : "Bienvenue sur BoxFit Premium"}
              </h2>

              <h2
                style={{
                  fontSize: "20px",
                }}
              >
                {status === "ko"
                  ? "Malheureusement, quelque chose s'est produit avec votre paiement. Veuillez réessayer."
                  : "Vous pouvez utiliser BoxFit Premium et profiter de toutes ses fonctionnalités."}{" "}
              </h2>

              <div style={{ height: "10px" }}></div>

              {status === "ko" ? (
                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    this.props.history.push("/upgrade");
                  }}
                >
                  Try again
                </button>
              ) : (
                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    this.props.history.push("/select-workout");
                  }}
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  Start a Workout
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createStripe: (creds) => dispatch(createStripe(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
